import { mapToNamedProperty, NamedProperty } from "sprint-common-web";

import { SystemPlatformDetailsResponse } from "../../../common/api/orders-api/airline/GetSystemPlatformDetailsResponse";
import { DynamicSubtitleType } from "../../../common/types/DynamicSubtitleType";
import { EncodeSpecificationContentType } from "../../../common/types/EncodeSpecificationContentType";
import { mapToIntegrator } from "../../../common/types/Integrator";
import { MuxSpecification } from "../../../common/types/MuxSpecification";
import { OrderAudioProxyType } from "../../../orders/common/types/OrderAudioProxyType";

export interface SystemPlatformDetailsItem {
    system: NamedProperty;
    integrator: NamedProperty;
    airline: NamedProperty;
    specifications: SystemPlatformDetailsSpecificationItem[];
    encodeConfiguration: SystemPlatformDetailsEncodeConfigurationItem;
    deliveryInfo: SystemPlatformDetailsDeliveryInfoItem;
    buzzIds: string[];
    shreqIds: string[];
}

export interface SystemPlatformDetailsSpecificationItem {
    encodeSpecificationContentType: EncodeSpecificationContentType;
    defaultEncodeSpecificationId: string | undefined;
    defaultEncodeSpecificationName: string | undefined;
    encodeSpecifications: NamedProperty[];
    isModified?: boolean;
}

export interface SystemPlatformDetailsEncodeConfigurationItem {
    muxSpecification: MuxSpecification | undefined;
    audioProxyType: OrderAudioProxyType | undefined;
    subtitlesTargetFileName: string | undefined;
    muxSubtitleType: DynamicSubtitleType | undefined;
    copySubtitleType: DynamicSubtitleType | undefined;
    closedCaptionCode?: string;
    subtitlesCaptionCode?: string;
    languageSpecification: NamedProperty | undefined;
}

export interface SystemPlatformDetailsDeliveryInfoItem {
    deliveryEndpoint: NamedProperty | undefined;
    distributionList: NamedProperty | undefined;
}

export const mapToSystemPlatformDetailsItem = (
    systemPlatform: SystemPlatformDetailsResponse,
    airline: NamedProperty
): SystemPlatformDetailsItem => {
    return {
        system: mapToNamedProperty(systemPlatform.system),
        integrator: mapToIntegrator(systemPlatform.integrator),
        airline: mapToNamedProperty(airline),
        specifications: systemPlatform.specifications.map((specification) => {
            return {
                encodeSpecificationContentType: specification.encodeSpecificationContentType,
                defaultEncodeSpecificationId: specification.defaultEncodeSpecification?.id,
                defaultEncodeSpecificationName: specification.defaultEncodeSpecification?.name,
                encodeSpecifications: specification.encodeSpecifications
            };
        }),
        encodeConfiguration: {
            audioProxyType: systemPlatform.audioProxyType,
            muxSpecification: systemPlatform.muxSpecification ?? undefined,
            muxSubtitleType: systemPlatform.muxSubtitleType,
            copySubtitleType: systemPlatform.copySubtitleType,
            subtitlesTargetFileName: systemPlatform.subtitlesTargetFileName,
            closedCaptionCode: systemPlatform.captionCode.closedCaption,
            subtitlesCaptionCode: systemPlatform.captionCode.subtitles,
            languageSpecification: systemPlatform.languageSpecification
                ? mapToNamedProperty(systemPlatform.languageSpecification)
                : undefined
        },
        deliveryInfo: {
            deliveryEndpoint: systemPlatform.deliveryEndpoint
                ? mapToNamedProperty(systemPlatform.deliveryEndpoint)
                : undefined,
            distributionList: systemPlatform.distributionList
                ? mapToNamedProperty(systemPlatform.distributionList)
                : undefined
        },
        buzzIds: systemPlatform.buzzIds,
        shreqIds: systemPlatform.shreqIds
    };
};
